import React, { createContext, useState, useContext } from 'react';

import { WidthObserver } from '@atlaskit/width-detector';

export const ContentWidthContext = createContext<number | undefined>(undefined);

export const useContentWidth = (): number | undefined =>
  useContext(ContentWidthContext);

export const ContentWidthProvider: React.FC<{
  gutterWidth: number;
}> = ({ children, gutterWidth }) => {
  const [width, setWidth] = useState<number>();

  return (
    <ContentWidthContext.Provider value={width ? width - gutterWidth : width}>
      <WidthObserver setWidth={setWidth} offscreen />
      {children}
    </ContentWidthContext.Provider>
  );
};
